import { FC } from 'react';

import {
  HOLIDAY_CALL_CENTER_HOURS,
  HOLIDAY_NOTICE_LABEL,
  isHolidayNoticePeriod,
} from '../../utils/holidayNotice';

//* 전화번호 아래 한 줄 배지 — 메인·체크아웃 전화박스 공용.
//* 별도 띠로 빼면 박스가 50px 커져 모바일에서 상품이 밀리므로, 기존 안내 줄 자리에 인라인으로 둔다.
//* 고정 높이 금지(기기 글자 확대 시 넘침), 배지+문구는 줄바꿈 허용.
export const HolidayCallCenterNotice: FC = () => {
  if (!isHolidayNoticePeriod()) return null;
  return (
    <p className="flex flex-wrap items-center gap-x-1.5 gap-y-0.5 text-[11px] font-normal text-gray-800">
      <span className="rounded-full bg-warn px-1.5 py-px font-bold leading-4 text-white">
        {HOLIDAY_NOTICE_LABEL}
      </span>
      <span className="break-keep">
        단축운영 <span className="font-bold text-warn">{HOLIDAY_CALL_CENTER_HOURS}</span>
      </span>
    </p>
  );
};
